module.exports = {
    handle: (e, data) => {
        const gtmProductList = data.gtmData && data.gtmData.product ? data.gtmData.product : null;
        const { customerId, emailAddress } = data.gtmData;

        if (!gtmProductList || gtmProductList.length === 0) {
            return;
        }

        const gtmProductData = gtmProductList[0] ? gtmProductList[0] : null;

        if (!gtmProductData) {
            return;
        }

        const {
            gtmData: {
                currencyCode
            }
        } = data;

        const {
            name,
            id,
            price,
            brand,
            category,
            variant,
            quantity
        } = gtmProductData;

        dataLayer.push({ ecommerce: null });

        const productData = {
            'event': 'removefromCart',
            'ecommerce': {
                'currencyCode': currencyCode,
                'remove': {
                    'products': [{
                        'name': name,
                        'id': id,
                        'price': price,
                        'brand': brand,
                        'category': category,
                        'variant': variant,
                        'quantity': quantity
                    }]
                }
            }
        };

        customerId ? productData.userId = customerId : null;
        emailAddress ? productData.email = emailAddress : null;

        dataLayer.push(productData);
    }
}